import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import { Button } from "rsuite";

class DevEnvironmentReviewForm extends Component {
  render() {
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        var dates = [
          "deis",
          "feis",
          "fonsi",
          "notice_of_intent",
          "record_of_decision",
          "supplemental_eis"
        ];
        if (Object.keys(errors).length !== 0) {
          this.props.setFieldTouched("deis", true);
          this.props.setFieldTouched("feis", true);
          this.props.setFieldTouched("fonsi", true);
          this.props.setFieldTouched("notice_of_intent", true);
          this.props.setFieldTouched("record_of_decision", true);
          this.props.setFieldTouched("supplemental_eis", true);
          this.props.setFieldTouched("estimated_construction_duration", true);
          this.props.setFieldTouched("estimated_schedule_contingency", true);
          this.props.setFieldTouched(
            "post_construction_forecasted_crash_rate",
            true
          );
          this.props.setFieldTouched(
            "post_construction_forecasted_traffic_by_concession_term_end",
            true
          );
          this.props.setFieldTouched(
            "post_construction_forecasted_traffic_for_year_1",
            true
          );
          this.props.setFieldTouched(
            "post_construction_forecasted_traffic_for_year_10",
            true
          );
          this.props.setFieldTouched(
            "post_construction_forecasted_traffic_for_year_2",
            true
          );
          this.props.setFieldTouched(
            "post_construction_forecasted_traffic_for_year_20",
            true
          );
          this.props.setFieldTouched(
            "post_construction_forecasted_traffic_for_year_3",
            true
          );
          this.props.setFieldTouched("pre_construction_crash_rate", true);
          this.props.setFieldTouched("pre_construction_traffic_volume", true);

          console.log("cannot submit! Validation failed", errors);
        } else {
          values.project_id = this.props.projectID;

          dates.forEach(field => {
            if (values[field]) {
              values[field] = new Date(values[field]).toJSON();
            }
          });
          func(values);
          this.props.resetForm();
          this.props.toggleSmallModalHandler();
        }
      });
    };

    return (
      <Form>
        {" "}
        <fieldset disabled={this.props.disabled}>
          {" "}
          <div
            onClick={this.props.toggleSmallModalHandler}
            style={{ color: "red", float: "right", cursor: "pointer" }}
          >
            x
          </div>
          <small className={"d-block col-12"}>
            <span style={{ color: "red" }}>*</span> required
          </small>
          <label className="col-3 pl-2">
            Benefit Cost Analysis
            <Field
              className="form-control"
              name={"benefit_cost_analysis"}
              value={this.props.values.benefit_cost_analysis || null}
            />
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors.deis &&
              this.props.touched.deis && { color: "red" }
            }
          >
            DEIS
            <Field
              className="form-control"
              name={"deis"}
              value={this.props.values.deis || null}
            />
            {this.props.errors.deis && this.props.touched.deis && (
              <small className={"text-danger"}>{this.props.errors.deis}</small>
            )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors.estimated_construction_duration &&
              this.props.touched.estimated_construction_duration && {
                color: "red"
              }
            }
          >
            Estimated Construction Duration
            <Field
              className="form-control"
              name={"estimated_construction_duration"}
              value={this.props.values.estimated_construction_duration || null}
            />
            {this.props.errors.estimated_construction_duration &&
              this.props.touched.estimated_construction_duration && (
                <small className={"text-danger"}>
                  {this.props.errors.estimated_construction_duration}
                </small>
              )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors.estimated_schedule_contingency &&
              this.props.touched.estimated_schedule_contingency && {
                color: "red"
              }
            }
          >
            Estimated Schedule Contingency
            <Field
              className="form-control"
              name={"estimated_schedule_contingency"}
              value={this.props.values.estimated_schedule_contingency || null}
            />
            {this.props.errors.estimated_schedule_contingency &&
              this.props.touched.estimated_schedule_contingency && (
                <small className={"text-danger"}>
                  {this.props.errors.estimated_schedule_contingency}
                </small>
              )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors.feis &&
              this.props.touched.feis && { color: "red" }
            }
          >
            FEIS
            <Field
              className="form-control"
              name={"feis"}
              value={this.props.values.feis || null}
            />
            {this.props.errors.feis && this.props.touched.feis && (
              <small className={"text-danger"}>{this.props.errors.feis}</small>
            )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors.fonsi &&
              this.props.touched.fonsi && { color: "red" }
            }
          >
            FONSI
            <Field
              className="form-control"
              name={"fonsi"}
              value={this.props.values.fonsi || null}
            />
            {this.props.errors.fonsi && this.props.touched.fonsi && (
              <small className={"text-danger"}>{this.props.errors.fonsi}</small>
            )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors.notice_of_intent &&
              this.props.touched.notice_of_intent && { color: "red" }
            }
          >
            Notice of Intent
            <Field
              className="form-control"
              name={"notice_of_intent"}
              value={this.props.values.notice_of_intent || null}
            />
            {this.props.errors.notice_of_intent &&
              this.props.touched.notice_of_intent && (
                <small className={"text-danger"}>
                  {this.props.errors.notice_of_intent}
                </small>
              )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors.post_construction_forecasted_crash_rate &&
              this.props.touched.post_construction_forecasted_crash_rate && {
                color: "red"
              }
            }
          >
            Post Construction Forecasted Crash Rate
            <Field
              className="form-control"
              name={"post_construction_forecasted_crash_rate"}
              value={
                this.props.values.post_construction_forecasted_crash_rate ||
                null
              }
            />
            {this.props.errors.post_construction_forecasted_crash_rate &&
              this.props.touched.post_construction_forecasted_crash_rate && (
                <small className={"text-danger"}>
                  {this.props.errors.post_construction_forecasted_crash_rate}
                </small>
              )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors
                .post_construction_forecasted_traffic_by_concession_term_end &&
              this.props.touched
                .post_construction_forecasted_traffic_by_concession_term_end && {
                color: "red"
              }
            }
          >
            Post Construction Forecasted Traffic by Concession Term End
            <Field
              className="form-control"
              name={
                "post_construction_forecasted_traffic_by_concession_term_end"
              }
              value={
                this.props.values
                  .post_construction_forecasted_traffic_by_concession_term_end ||
                null
              }
            />
            {this.props.errors
              .post_construction_forecasted_traffic_by_concession_term_end &&
              this.props.touched
                .post_construction_forecasted_traffic_by_concession_term_end && (
                <small className={"text-danger"}>
                  {
                    this.props.errors
                      .post_construction_forecasted_traffic_by_concession_term_end
                  }
                </small>
              )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors
                .post_construction_forecasted_traffic_for_year_1 &&
              this.props.touched
                .post_construction_forecasted_traffic_for_year_1 && {
                color: "red"
              }
            }
          >
            Post Construction Forecasted Traffic for Year 1
            <Field
              className="form-control"
              name={"post_construction_forecasted_traffic_for_year_1"}
              value={
                this.props.values
                  .post_construction_forecasted_traffic_for_year_1 || null
              }
            />
            {this.props.errors
              .post_construction_forecasted_traffic_for_year_1 &&
              this.props.touched
                .post_construction_forecasted_traffic_for_year_1 && (
                <small className={"text-danger"}>
                  {
                    this.props.errors
                      .post_construction_forecasted_traffic_for_year_1
                  }
                </small>
              )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors
                .post_construction_forecasted_traffic_for_year_10 &&
              this.props.touched
                .post_construction_forecasted_traffic_for_year_10 && {
                color: "red"
              }
            }
          >
            Post Construction Forecasted Traffic for Year 10
            <Field
              className="form-control"
              name={"post_construction_forecasted_traffic_for_year_10"}
              value={
                this.props.values
                  .post_construction_forecasted_traffic_for_year_10 || null
              }
            />
            {this.props.errors
              .post_construction_forecasted_traffic_for_year_10 &&
              this.props.touched
                .post_construction_forecasted_traffic_for_year_10 && (
                <small className={"text-danger"}>
                  {
                    this.props.errors
                      .post_construction_forecasted_traffic_for_year_10
                  }
                </small>
              )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors
                .post_construction_forecasted_traffic_for_year_2 &&
              this.props.touched
                .post_construction_forecasted_traffic_for_year_2 && {
                color: "red"
              }
            }
          >
            Post Construction Forecasted Traffic For Year 2
            <Field
              className="form-control"
              name={"post_construction_forecasted_traffic_for_year_2"}
              value={
                this.props.values
                  .post_construction_forecasted_traffic_for_year_2 || null
              }
            />
            {this.props.errors
              .post_construction_forecasted_traffic_for_year_2 &&
              this.props.touched
                .post_construction_forecasted_traffic_for_year_2 && (
                <small className={"text-danger"}>
                  {
                    this.props.errors
                      .post_construction_forecasted_traffic_for_year_2
                  }
                </small>
              )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors
                .post_construction_forecasted_traffic_for_year_20 &&
              this.props.touched
                .post_construction_forecasted_traffic_for_year_20 && {
                color: "red"
              }
            }
          >
            Post Construction Forecasted Traffic for Year 20
            <Field
              className="form-control"
              name={"post_construction_forecasted_traffic_for_year_20"}
              value={
                this.props.values
                  .post_construction_forecasted_traffic_for_year_20 || null
              }
            />
            {this.props.errors
              .post_construction_forecasted_traffic_for_year_20 &&
              this.props.touched
                .post_construction_forecasted_traffic_for_year_20 && (
                <small className={"text-danger"}>
                  {
                    this.props.errors
                      .post_construction_forecasted_traffic_for_year_20
                  }
                </small>
              )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors
                .post_construction_forecasted_traffic_for_year_3 &&
              this.props.touched
                .post_construction_forecasted_traffic_for_year_3 && {
                color: "red"
              }
            }
          >
            Post Construction Forecasted Traffic for Year 3
            <Field
              className="form-control"
              name={"post_construction_forecasted_traffic_for_year_3"}
              value={
                this.props.values
                  .post_construction_forecasted_traffic_for_year_3 || null
              }
            />
            {this.props.errors
              .post_construction_forecasted_traffic_for_year_3 &&
              this.props.touched
                .post_construction_forecasted_traffic_for_year_3 && (
                <small className={"text-danger"}>
                  {
                    this.props.errors
                      .post_construction_forecasted_traffic_for_year_3
                  }
                </small>
              )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors.pre_construction_crash_rate &&
              this.props.touched.pre_construction_crash_rate && { color: "red" }
            }
          >
            Pre Construction Crash Rate
            <Field
              className="form-control"
              name={"pre_construction_crash_rate"}
              value={this.props.values.pre_construction_crash_rate || null}
            />
            {this.props.errors.pre_construction_crash_rate &&
              this.props.touched.pre_construction_crash_rate && (
                <small className={"text-danger"}>
                  {this.props.errors.pre_construction_crash_rate}
                </small>
              )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors.pre_construction_traffic_volume &&
              this.props.touched.pre_construction_traffic_volume && {
                color: "red"
              }
            }
          >
            Pre Construction Traffic Volume
            <Field
              className="form-control"
              name={"pre_construction_traffic_volume"}
              value={this.props.values.pre_construction_traffic_volume || null}
            />
            {this.props.errors.pre_construction_traffic_volume &&
              this.props.touched.pre_construction_traffic_volume && (
                <small className={"text-danger"}>
                  {this.props.errors.pre_construction_traffic_volume}
                </small>
              )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors.record_of_decision &&
              this.props.touched.record_of_decision && { color: "red" }
            }
          >
            Record of Decision
            <Field
              className="form-control"
              name={"record_of_decision"}
              value={this.props.values.record_of_decision || null}
            />
            {this.props.errors.record_of_decision &&
              this.props.touched.record_of_decision && (
                <small className={"text-danger"}>
                  {this.props.errors.record_of_decision}
                </small>
              )}
          </label>
          <label
            className="col-3 pl-2"
            style={
              this.props.errors.supplemental_eis &&
              this.props.touched.supplemental_eis && { color: "red" }
            }
          >
            Supplemental EIS
            <Field
              className="form-control"
              name={"supplemental_eis"}
              value={this.props.values.supplemental_eis || null}
            />
            {this.props.errors.supplemental_eis &&
              this.props.touched.supplemental_eis && (
                <small className={"text-danger"}>
                  {this.props.errors.supplemental_eis}
                </small>
              )}
          </label>
          <label className="col-3 pl-2">
            Value for Money Study
            <Field
              className="form-control"
              name={"value_for_money_study"}
              value={this.props.values.value_for_money_study || ""}
            />
          </label>
          <label className="col-6 pl-2 d-block">
            Notes
            <Field
              component={"textarea"}
              rows={4}
              className="form-control"
              name={"notes"}
              value={this.props.values.notes || ""}
            />
          </label>
          <label className="col-6 pl-2 d-block">
            Environmental Impact and Commitment Summary
            <Field
              component={"textarea"}
              rows={8}
              className="form-control"
              name={"environmental_impact_and_commitment_summary"}
              value={
                this.props.values.environmental_impact_and_commitment_summary ||
                ""
              }
            />
          </label>
        </fieldset>
        {this.props.disabled ? (
          <Button
            type="button"
            onClick={this.props.toggleSmallModalHandler}
            className="ml-2"
          >
            Cancel
          </Button>
        ) : (
          <div>
            {!this.props.currentDevEnvironmentReview ? (
              <Button
                type="button"
                color="blue"
                onClick={() => {
                  validAndHandle(this.props.add, this.props.values);
                }}
              >
                Submit
              </Button>
            ) : (
              <Button
                type="button"
                color="blue"
                onClick={() => {
                  validAndHandle(this.props.update, this.props.values);
                }}
              >
                Update
              </Button>
            )}
            <Button
              color={"red"}
              type="button"
              onClick={this.props.handleReset}
              className="ml-2"
            >
              Reset
            </Button>
            <Button
              type="button"
              onClick={this.props.toggleSmallModalHandler}
              className="ml-2"
            >
              Cancel
            </Button>
          </div>
        )}
      </Form>
    );
  }
}

var devEnvironmentReviewSchema = Yup.object().shape({
  deis: Yup.date()
    .nullable()
    .typeError("Invalid date"),
  feis: Yup.date()
    .nullable()
    .typeError("Invalid date"),
  fonsi: Yup.date()
    .nullable()
    .typeError("Invalid date"),
  notice_of_intent: Yup.date()
    .nullable()
    .typeError("Invalid date"),
  record_of_decision: Yup.date()
    .nullable()
    .typeError("Invalid date"),
  supplemental_eis: Yup.date()
    .nullable()
    .typeError("Invalid date"),
  estimated_construction_duration: Yup.number()
    .nullable()
    .typeError("Number required"),
  estimated_schedule_contingency: Yup.number()
    .nullable()
    .typeError("Number required"),
  post_construction_forecasted_crash_rate: Yup.number()
    .nullable()
    .typeError("Number required"),
  post_construction_forecasted_traffic_by_concession_term_end: Yup.number()
    .nullable()
    .typeError("Number required"),
  post_construction_forecasted_traffic_for_year_1: Yup.number()
    .nullable()
    .typeError("Number required"),
  post_construction_forecasted_traffic_for_year_10: Yup.number()
    .nullable()
    .typeError("Number required"),
  post_construction_forecasted_traffic_for_year_2: Yup.number()
    .nullable()
    .typeError("Number required"),
  post_construction_forecasted_traffic_for_year_20: Yup.number()
    .nullable()
    .typeError("Number required"),
  post_construction_forecasted_traffic_for_year_3: Yup.number()
    .nullable()
    .typeError("Number required"),
  pre_construction_crash_rate: Yup.number()
    .nullable()
    .typeError("Number required"),
  pre_construction_traffic_volume: Yup.number()
    .nullable()
    .typeError("Number required")
});

export default withFormik({
  validationSchema: devEnvironmentReviewSchema,
  enableReinitialize: true,

  mapPropsToValues({ currentDevEnvironmentReview }) {
    return {
      ...currentDevEnvironmentReview
    };
  }
})(DevEnvironmentReviewForm);
